import React, { useCallback } from 'react';
import * as R from 'ramda';
import { getGanttConfig } from '@constants/config';
import { DropdownFilter, useDropdownFilter } from './base-dropdown-filter';

const DateFilter = () => {
  const getItems = useCallback(
    () => R.values(getGanttConfig().dateUnits).map(dateUnit => ({
      id: dateUnit.id,
      name: dateUnit.label
    })),
    []
  );

  const {
    items,
    filterChange,
    filterClose,
    getChecked,
    selected
  } = useDropdownFilter({
    name: 'dateUnit',
    getItems
  });

  const renderValue = useCallback(() => {
    const { label } = R.values(getGanttConfig().dateUnits).find(dateUnit => dateUnit.id === selected);
    return `View by ${label}`;
  }, [selected]);

  return (
    <DropdownFilter
      items={items}
      multiple={false}
      filterChange={filterChange}
      filterClose={filterClose}
      renderValue={renderValue}
      getChecked={getChecked}
      selected={selected}
    />
  );
};

export default DateFilter;
